module.exports = __webpack_public_path__ + "static/yy-1936e167970d446232ec208d20dc675b.png";